import { showToastMessage } from "@lonelyplanet/dotcom-core/dist/actions/toast";
export var getBookmarkListUrl = function (profileHost, username, listId) { return profileHost + "/profile/" + username + "/lists/" + listId; };
export var showBookmarkSuccessToast = function (isBookmarked, profileHost, username, list) {
    var msg = isBookmarked
        ? "Added to " + list.name + "."
        : "Removed from " + list.name + ".";
    var url = getBookmarkListUrl(profileHost, username, list.id);
    return showToastMessage(msg, "success", "See list", url);
};
export var showBookmarkErrorToast = function (isBookmarked, profileHost, username, list) {
    var msg = isBookmarked
        ? "Failed to add to " + list.name + "."
        : "Failed to remove from " + list.name + ".";
    var url = getBookmarkListUrl(profileHost, username, list.id);
    return showToastMessage(msg, "error", "See list", url);
};
export var showBookmarkListErrorToast = function (list) {
    return showToastMessage("Failed to create " + list.name + ".", "error");
};



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/utils/toasts.ts
// module id = jsBX
// module chunks = 2